import React from "react";
import "./howwork.css";
import { Container, Row, Tab, Tabs } from "react-bootstrap";
import { useState } from "react";
function Howwork() {
  const [key, setKey] = useState("createmain");
  return (
    <>
      <Container>
        <Row>
          <div className="col-md-12 ">
            <Tabs
              id="controlled-tab-example"
              activeKey={key}
              onSelect={(k) => setKey(k)}
              className="mb-3 mt-4 text-center">
              <Tab
                className="text-center py-5"
                eventKey="createmain"
                title="كيفية إنشاء حساب">
                <div>
                  <iframe
                    title="myFrame"
                    width="80%"
                    height="500"
                    src="https://www.youtube.com/embed/d5V08GS5oss"></iframe>
                </div>
              </Tab>
              <Tab
                className="text-center py-5"
                eventKey="tawkel"
                title="إدارة التوكيلات">
                <div>
                  <iframe
                    title="myFrame"
                    width="80%"
                    height="500"
                    src="https://www.youtube.com/embed/5RwRC7tdlpk"></iframe>
                </div>
              </Tab>
              <Tab
                className="text-center py-5"
                eventKey="createsub"
                title="إدارة الدعاوي">
                <div>
                  <iframe
                    title="myFrame"
                    width="80%"
                    height="500"
                    src="https://www.youtube.com/embed/OPEKq6W0F3k"></iframe>
                </div>
              </Tab>
              <Tab
                className="text-center py-5"
                eventKey="createtran"
                title="إدارة الأجندة القضائية">
                <div>
                  <iframe
                    title="myFrame"
                    width="80%"
                    height="500"
                    src="https://www.youtube.com/embed/t2iP_Scf7rA"></iframe>
                </div>
              </Tab>
              <Tab
                className="text-center py-5"
                eventKey="createsubscripe"
                title="إدارة العمل الأداري">
                <div>
                  <iframe
                    title="myFrame"
                    width="80%"
                    height="500"
                    src="https://www.youtube.com/embed/GO8FpayvTco"></iframe>
                </div>
              </Tab>
              <Tab
                className="text-center py-5"
                eventKey="subscribe"
                title="كيفية الإشتراك">
                <div>
                  <iframe
                    title="myFrame"
                    width="80%"
                    height="500"
                    src="https://www.youtube.com/embed/tEgN6j-ZDCM"></iframe>
                </div>
              </Tab>
              <Tab
                className="text-center py-5"
                eventKey="downloadapp"
                title="تحميل أجندة المحامي القضائية">
                <div>
                  <iframe
                    title="myFrame"
                    width="80%"
                    height="500"
                    src="https://www.youtube.com/embed/qBrJHTQ2LeE"></iframe>
                </div>
              </Tab>
            </Tabs>
          </div>
        </Row>
      </Container>
    </>
  );
}

export default Howwork;
